import { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import {
  selectDVCPMATrackingForecastChartType,
  selectDVCPMATrackingForecastSubpage,
  setChartType,
  setSubpage,
} from 'redux/reducers/meteorologyAgroTrackingForecastDetailedViewControlPanelReducer';
import { store } from 'redux/store';
import { ChartType, Subpage, SUBPAGE_NAMES } from 'types/Meteorology/Agro/TrackingForecast/DetailedView';

export default function useControls() {
  const currentSubpage = useSelector(selectDVCPMATrackingForecastSubpage);
  const subpageButtonProps = useMemo(() => Object.keys(SUBPAGE_NAMES).map((subpage) => ({
    text: SUBPAGE_NAMES[subpage],
    onClick: () => { store.dispatch(setSubpage(subpage as Subpage)); },
    active: currentSubpage === subpage,
  })), [currentSubpage]);
  const chartMode: ChartType = useSelector(selectDVCPMATrackingForecastChartType);
  const setChartMode = useCallback((v: ChartType) => {
    store.dispatch(setChartType(v));
  }, []);

  return {
    subpageButtonProps,
    chartMode,
    setChartMode,
  };
}
